import { 
    CREATEPATHOLOGYOPDTEST,
    CREATEPATHOLOGYTEST, 
    CREATEPATHOLOGYTESTPARAMETER, 
    DELETEPATHOLOGYOPDTEST, 
    DELETEPATHOLOGYTEST, 
    DELETEPATHOLOGYTESTPARAMETER, 
    GETPATHOLOGYOPDTEST, 
    GETPATHOLOGYTEST, 
    GETPATHOLOGYTESTPARAMETER, 
    UPDATEPATHOLOGYOPDTEST, 
    UPDATEPATHOLOGYTEST, 
    UPDATEPATHOLOGYTESTPARAMETER 
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPATHOLOGYTEST:
            return {
                ...state,
                pathologytestSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYTEST:
                return {
                        ...state,
                        pathologytestList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYTEST:
                return {
                        ...state,
                        pathologytestUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYTEST:
                 return {
                     ...state,
                     pathologytestDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYTESTPARAMETER:
            return {
                ...state,
                pathologytestparameterSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYTESTPARAMETER:
                return {
                        ...state,
                        pathologytestparameterList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYTESTPARAMETER:
                return {
                        ...state,
                        pathologytestparameterUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYTESTPARAMETER:
                 return {
                     ...state,
                     pathologytestparameterDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYOPDTEST:
            return {
                ...state,
                opdpathologytestSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYOPDTEST:
                return {
                        ...state,
                        opdpathologytestList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYOPDTEST:
                return {
                        ...state,
                        opdpathologytestUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYOPDTEST:
                 return {
                     ...state,
                     opdpathologytestDeleteStatus: action.payload.success,
                        } 
       
                        default:
                            return state
                             }
                         }